import axios from 'axios';
import {
  UPDATE_BUSINESS_START_YEAR,
  UPDATE_BUSINESS_REVENUE,
  UPDATE_BUSINESS,
} from './constant';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function updateBusinessSstartApi(params) {
  const { businessId, start_year } = params;
  return axios
    .put(
      UPDATE_BUSINESS_START_YEAR(businessId),
      { start_year },
      { withCredentials: true }
    )
    .catch(reject);
}

export function updateBusinessRevenueApi(params) {
  const { businessId, revenue } = params;
  return axios
    .put(
      UPDATE_BUSINESS_REVENUE(businessId),
      { revenue },
      { withCredentials: true }
    )
    .catch(reject);
}

export function updateBusiness(params) {
  return axios
    .put(UPDATE_BUSINESS, params, { withCredentials: true })
    .catch(reject);
}
